import { MutationTree } from 'vuex';
import { TemplatesState } from './types';

export const mutations: MutationTree<TemplatesState> = {
    setMNTemplates:(state, data) => {
        state.mnTemplates = data
    },
    setMNMultichannelTemplates:(state, data) => {
        state.mnMultichannelTemplates = data
    },
    setMNTemplateItem:(state, data) => {
        state.mnTemplateItem = data
    },
    setMNServices:(state, data) => {
        state.mnServices = data
    },
};